/* CycleCNC Industrial Theme — theme.js */

(function () {
  'use strict';

  // Cart drawer toggle
  const cartDrawer = document.getElementById('CartDrawer');
  const cartTrigger = document.querySelector('[data-cart-toggle]');
  const cartClose = document.querySelector('[data-cart-close]');

  function openCart() {
    if (cartDrawer) {
      cartDrawer.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
    }
  }
  function closeCart() {
    if (cartDrawer) {
      cartDrawer.removeAttribute('open');
      document.body.style.overflow = '';
    }
  }
  if (cartTrigger) cartTrigger.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);

  // Mobile menu toggle
  const mobileDrawer = document.getElementById('MobileDrawer');
  const mobileTrigger = document.querySelector('[data-mobile-toggle]');
  const mobileClose = document.querySelector('[data-mobile-close]');
  if (mobileTrigger) mobileTrigger.addEventListener('click', () => mobileDrawer.setAttribute('open', ''));
  if (mobileClose) mobileClose.addEventListener('click', () => mobileDrawer.removeAttribute('open'));

  // Product variant selector
  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    const variantSelect = productForm.querySelector('[data-variant-select]');
    const optionInputs = productForm.querySelectorAll('[data-option-input]');
    const priceTarget = document.querySelector('[data-product-price]');
    const productJsonScript = document.querySelector('[data-product-json]');
    if (productJsonScript) {
      const productData = JSON.parse(productJsonScript.textContent);
      optionInputs.forEach((input) => {
        input.addEventListener('change', () => {
          const selectedOptions = Array.from(optionInputs)
            .filter(i => i.checked || i.tagName === 'SELECT')
            .map(i => i.value);
          const variant = productData.variants.find(v => {
            return JSON.stringify(v.options) === JSON.stringify(selectedOptions);
          });
          if (variant) {
            if (variantSelect) variantSelect.value = variant.id;
            if (priceTarget) {
              priceTarget.textContent = formatMoney(variant.price);
            }
          }
        });
      });
    }
  }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify ? Shopify.currency.active : 'EUR'
    }).format(amount);
  }

  // Quantity stepper
  document.querySelectorAll('[data-quantity-step]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input[type="number"]');
      const step = parseInt(btn.dataset.quantityStep, 10);
      const current = parseInt(input.value, 10) || 1;
      const newValue = Math.max(1, current + step);
      input.value = newValue;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
})();
